import { images } from "../source";

export const milestoneData = [
  {
    year: "2017",
    desc: "Registered as a startup and incubated under the IITM Incubation Cell.",
  },
  {
    year: "2018",
    desc: "Achieved commercial validation of our coating through customer trials and laboratory testing.",
  },
  {
    year: "2019",
    desc: "Won the #1 start-up award in DRDO’s Dare to Dream Innovation Contest for providing an innovative solution for efficient thermal management of intercontinental ballistic missiles.",
  },
  {
    year: "2020",
    desc: "Expanded our focus to the water and wastewater treatment sector, leveraging the potential of the Boron Doped Diamond (BDD) electrode.",
  },
  {
    year: "2021",
    desc: "Secured funding from BIRAC and MSME for developing and commercializing diamond technology-based wastewater treatment modules.",
  },
  {
    year: "2022",
    desc: "Developed our indigenous HFCVD reactor and diamond coating recipe.",
  },
  {
    year: "2023",
    desc: "Launch of Diamist, an innovative disinfectant device powered by diamond-based technology, at Aquatech Amsterdam.",
  },
  {
    year: "2024",
    desc: "Established a dedicated manufacturing facility and innovation center at the IIT Madras Research Park.",
  },
];
export const teamData = [
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
  {
    img: images.teamdummy.image,
    name: "John Doe",
    desg: "Designation",
  },
];
